import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CTASection from '../components/CTASection';
import WhyChooseUs from '../components/WhyChooseUs';
import ProcessSection from '../components/ProcessSection';
import CertificationsStrip from '../components/CertificationsStrip';
import SEO from '../components/SEO';
import { galleryImages, stats } from '../mock';

export default function AboutPage() {
  return (
    <div>
      <SEO
        title="About Us — Welding Electrode Manufacturer Since 1985"
        description="Prakash Electrodes Private Limited has manufactured premium welding electrodes in Kota, Rajasthan since 1985. Learn about our 40-year legacy of quality."
        path="/about"
      />
      <Navbar />

      {/* Hero */}
      <section className="relative bg-[#0b0b0d] text-white pt-40 pb-24 overflow-hidden noise">
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute left-0 top-0 h-96 w-96 rounded-full bg-amber-500/20 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-end">
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-4">
              — About Prakash Electrodes
            </div>
            <h1 className="font-display text-5xl lg:text-6xl font-semibold leading-[1.02]">
              Quality welding
              <br /> <span className="text-amber-400">solutions since 1985.</span>
            </h1>
          </div>
          <p className="text-white/70 text-lg leading-relaxed">
            &ldquo;With decades of experience, Prakash Electrodes has honed its expertise in
            manufacturing premium-quality welding electrodes.&rdquo; Our knowledge of industry
            trends, coupled with a commitment to excellence, makes us a leader in the fabrication
            sector.
          </p>
        </div>
      </section>

      {/* Image collage + story */}
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <div className="grid grid-cols-6 gap-3">
            <img src={galleryImages[0]} alt="" className="col-span-4 aspect-[4/3] object-cover rounded-xl" />
            <img src={galleryImages[3]} alt="" className="col-span-2 aspect-square object-cover rounded-xl" />
            <img src={galleryImages[4]} alt="" className="col-span-3 aspect-[4/3] object-cover rounded-xl" />
            <img src={galleryImages[5]} alt="" className="col-span-3 aspect-[4/3] object-cover rounded-xl" />
          </div>

          <div>
            <h2 className="font-display text-3xl lg:text-4xl font-semibold text-[#0b0b0d] leading-[1.1]">
              A legacy forged in Kota&rsquo;s industrial heart.
            </h2>
            <div className="mt-6 space-y-4 text-neutral-700 leading-relaxed">
              <p>
                Prakash Electrodes Private Limited is a prominent name in the welding electrode
                manufacturing industry, based in Kota, Rajasthan. Since 1985, we have catered to
                the evolving demands of the industrial and construction sectors.
              </p>
              <p>
                With a diverse product range including renowned brands like Weldarc, CUTWELD,
                Hitkari Gold, BPL, and Sunlight, we ensure the highest standards of quality.
                Prakash Electrodes is synonymous with precision, durability, and cutting-edge
                features in welding solutions.
              </p>
              <p>
                Motivated by a passion for innovation, we embrace customer feedback to continuously
                refine our products. We adhere to principles of quality and service, striving to
                exceed client expectations in every welding solution.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl border border-neutral-200 p-5">
                  <div className="font-display text-3xl font-semibold text-[#0b0b0d]">
                    {s.value}
                  </div>
                  <div className="mt-1 text-xs uppercase tracking-[0.14em] text-neutral-500 font-mono">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <CertificationsStrip />
      <ProcessSection />
      <CTASection />
      <Footer />
    </div>
  );
}
